import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./styles.scss";
import { Col, Container, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { MdAdd } from "react-icons/md";
import randomString from "randomstring";
import PageHeader from "../../../../dashboard/components/page-header/PageHeader";
import { useFunctions, useStorage } from "reactfire";
import UserNotification from "../../../../../shared/components/Notification/UserNotification";
import FileTag from "./components/file-tag/FileTag";
import FormValidator from "../../../../../shared/utils/FormValidator";
import firebase from "firebase/app";
import { BarLoader } from "react-spinners";
import { useHistory, useLocation } from "react-router-dom";
import { DashboardMentoringPages } from "../../Mentoring";
import { zeroPad } from "../../../../../shared/utils/Commons";
import { IoMdDownload } from "react-icons/io";
import { useDropzone } from "react-dropzone";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import { Country, FileContent } from "../../../../../shared/constants/Constant";
import SelectCountry from "../../../../../shared/components/countrySelectorModal/SelectCountry";
import { MSessionRequest } from "../../components/session-preview/SessionPreview";
import MemberTag from "./components/member-tag/MemberTag";
import moment from "moment";
import { useAppContext } from "../../../../../contexts/app-context/AppContext";

export interface MentoringSessionRequest {
  id?: string;
  requestedTeamId: string;
  requestedTeamName: string;
  requestedTeamMemberId: string;
  requestedMentorId: string;
  country: Country;
  createdAt: string;
  requestedMentorName: string;
}
export interface AddMentoringSessionDTO {
  title: string;
  mentorId: string;
  teamId?: string;
  teamName?: string;
  startAt?: string;
  endAt?: string;
  mentorName: string;
  mentoringSessionRequest: MentoringSessionRequest;
  duration?: string;
  description: string;
  fileURLs?: FileContent[];
  meetingURL: string;
  country: Country;
}

export interface IState {
  title: string;
  titleError: string;
  mentorError: string;
  teamError: string;
  membersError: string;
  startDate: Date | null;
  startDateError: string;
  startTime: Time;
  startTimeError: string;
  endDate: Date | null;
  endDateError: string;
  endTime: Time;
  endTimeError: string;
  duration: string;
  durationError: string;
  description: string;
  descriptionError: string;
  fileURLs: string[];
  fileURLsError: string;
  meetingURL: string;
  meetingURLError: string;
  loading: boolean;
}

interface Time {
  h: number;
  m: number;
}

/*interface Mentor {
  id: string;
  name: string;
}*/

/*interface Member {
  id: string;
  name: string;
}*/

/*interface Team {
  id: string;
  name: string;
  members: Member[];
}*/

const initialState: IState = {
  title: "",
  titleError: "",
  mentorError: "",
  teamError: "",
  membersError: "",
  startDate: null,
  startDateError: "",
  startTime: { h: 0, m: 0 },
  startTimeError: "",
  endDate: null,
  endDateError: "",
  endTime: { h: 0, m: 0 },
  endTimeError: "",
  duration: "",
  durationError: "",
  description: "",
  descriptionError: "",
  fileURLs: [],
  fileURLsError: "",
  meetingURL: "",
  meetingURLError: "",
  loading: false,
};

const CreateSession = () => {
  const [modalShow, setModalShow] = useState(false);
  const addMentorSessionFunction = useFunctions().httpsCallable(
    "addMentorSession"
  );
  const [uploadElement, setUploadElement] = useState(null as any);

  const [selectedFiles, setSelectedFiles] = useState<
    { id: string; file: File; url: string }[]
  >([]);

  const [state, setState] = useState(initialState);
  const { userRole } = useAppUser();

  const location: any = useLocation();

  const session: MSessionRequest = location.state;
  const app = useAppContext();

  useEffect(() => {
    if (state.startDate)
      setState((ps) => ({ ...ps, endDate: state.startDate }));
  }, [state.startDate]);

  useEffect(() => {
    function addMinutes(time: Time, minsToAdd: string): Time {
      function D(J: number) {
        return (J < 10 ? "0" : "") + J;
      }
      let piece = [time.h, time.m];
      let mins: number = piece[0] * 60 + +piece[1] + +minsToAdd;

      return { h: +D(((mins % (24 * 60)) / 60) | 0), m: +D(mins % 60) };
    }
    if (state.startDate && state.startTime)
      setState((ps) => ({ ...ps, endTime: addMinutes(state.startTime, "30") }));
  }, [state.startDate, state.startTime]);

  const validateData = (): boolean => {
    //title
    const titleValidation = FormValidator.validateString(
      state.title,
      "Title",
      3,
      100
    );
    //start date
    const startDateValidation =
      state.startDate === null
        ? { message: "Please set a valid Start Date.", isValid: false }
        : FormValidator.validateWorkshopStartDate(
            state.startDate,
            "Start date"
          );
    const endDateValidation =
      state.endDate === null
        ? { message: "Please set a valid End Date.", isValid: false }
        : !FormValidator.areDatesEqual(
            state.endDate,
            state.startDate !== null ? state.startDate : new Date()
          ) &&
          state.endDate <
            (state.startDate !== null ? state.startDate : new Date())
        ? { message: "Please set a valid End Date.", isValid: false }
        : { message: "", isValid: true };

    const endTimeValidation =
      endDateValidation.isValid &&
      FormValidator.areDatesEqual(
        state.endDate || new Date(),
        state.startDate !== null ? state.startDate : new Date()
      )
        ? state.startTime.h > state.endTime.h ||
          (state.startTime.h === state.endTime.h &&
            state.startTime.m >= state.endTime.m)
          ? { message: "Please set a valid End Time.", isValid: false }
          : { message: "", isValid: true }
        : { message: "", isValid: true };

    //start time
    const today = new Date();
    const startTimeValidation =
      state.startDate &&
      startDateValidation.isValid &&
      FormValidator.areDatesEqual(new Date(), state.startDate)
        ? today.getHours() < state.startTime.h
          ? { message: "", isValid: true }
          : today.getHours() === state.startTime.h &&
            today.getMinutes() < state.startTime.m
          ? { message: "", isValid: true }
          : { message: "Please set a valid Start Time.", isValid: false }
        : { message: "", isValid: true };

    //end date
    //end time
    //duration
    //description
    const descriptionValidation = FormValidator.validateString(
      state.description,
      "Description",
      3,
      2000
    );
    //documents
    //meeting link
    const meetingLinkValidation = FormValidator.validateString(
      state.meetingURL,
      "Meeting link",
      -1,
      -1
    );
    setState({
      ...state,
      titleError: titleValidation.message,
      startDateError: startDateValidation.message,
      descriptionError: descriptionValidation.message,
      meetingURLError: meetingLinkValidation.message,
      endDateError: endDateValidation.message,
      endTimeError: endTimeValidation.message,
      startTimeError: startTimeValidation.message,
    });
    return (
      titleValidation.isValid &&
      startDateValidation.isValid &&
      descriptionValidation.isValid &&
      meetingLinkValidation.isValid &&
      endTimeValidation.isValid &&
      startDateValidation.isValid &&
      endDateValidation.isValid &&
      startTimeValidation.isValid
    );
  };

  const storage = useStorage().ref();
  const [loading, setLoading] = useState(false);
  const { push } = useHistory();

  const saveData = () => {
    if (validateData()) {
      setLoading(true);
      if (selectedFiles.length > 0) {
        const downloadUrlTasks: { file: File; task: Promise<string> }[] = [];
        const tasks = selectedFiles.map((f) => {
          const task = storage
            .child(`sessionresources/${f.file.name}`)
            .put(f.file);
          task.on(
            firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot) => {
              const progress =
                ((snapshot.bytesTransferred / snapshot.totalBytes) * 100) /
                selectedFiles.length;
              if (snapshot.state === firebase.storage.TaskState.RUNNING) {
                console.log(`Progress: ${progress}% - ${f.file.name}`);
              }
            },
            (error) => console.log(error.message),
            async () => {
              downloadUrlTasks.push({
                file: f.file,
                task: task.snapshot.ref.getDownloadURL(),
              });
            }
          );

          return task;
        });

        const urls: FileContent[] = [];
        Promise.all(tasks)
          .then(async () => {
            for (let utask of downloadUrlTasks) {
              const downloadURL = await utask.task;
              urls.push({
                url: downloadURL,
                fileName: utask.file?.name,
                type: utask.file.name.substr(
                  utask.file.name.lastIndexOf(".") + 1
                ),
              });
            }
            const startAt = state.startDate;
            const startAtFull = new Date(
              startAt?.getFullYear() || 0,
              startAt?.getMonth() || 0,
              startAt?.getDate() || -1,
              state.startTime.h,
              state.startTime.m
            );
            const endAt = state.endDate;
            const endAtFull = new Date(
              endAt?.getFullYear() || 0,
              endAt?.getMonth() || 0,
              endAt?.getDate() || -1,
              state.endTime.h,
              state.endTime.m
            );
            endAt?.setHours(state.endTime.h);
            endAt?.setMinutes(state.endTime.m);
            const data: AddMentoringSessionDTO = {
              title: state.title,
              description: state.description,
              fileURLs: urls,
              meetingURL: state.meetingURL,
              mentorName: session.mentorName,
              mentorId: session.mentorId,
              mentoringSessionRequest: {
                id: session.id,
                requestedTeamId: session.teamId,
                requestedTeamName: session.teamName,
                requestedTeamMemberId: session.memberId,
                requestedMentorId: session.mentorId,
                requestedMentorName: session.mentorName,
                country: session.country,
                createdAt: new Date(
                  session.createdAt.seconds * 1000
                ).toDateString(),
              },
              duration: getDateDeff(),
              teamId: session.teamId,
              teamName: session.teamName,
              endAt: endAtFull?.toString(),
              startAt: startAtFull?.toString(),
              country: session.country as Country,
            };

            addMentorSessionFunction(data)
              .then((res) => {
                UserNotification({
                  isSuccess: true,
                  message: "Session successfully created!",
                });
                console.log(res.data);
                app.pushBackURL(
                  DashboardMentoringPages.MENTORING_SESSION_REQUESTS
                );
                push(`/dashboard/sessions/session/${res.data.data}`);
              })
              .catch(() => {
                UserNotification({
                  isSuccess: false,
                  message: "Session creation failed!",
                });
              })
              .finally(() => {
                setLoading(false);
              });
          })
          .catch((err) => {
            setLoading(false);
            UserNotification({
              isSuccess: false,
              message: "Session creation failed!",
            });
          });
      } else {
        const startAt = state.startDate;
        const startAtFull = new Date(
          startAt?.getFullYear() || 0,
          startAt?.getMonth() || 0,
          startAt?.getDate() || -1,
          state.startTime.h,
          state.startTime.m
        );
        const endAt = state.endDate;
        const endAtFull = new Date(
          endAt?.getFullYear() || 0,
          endAt?.getMonth() || 0,
          endAt?.getDate() || -1,
          state.endTime.h,
          state.endTime.m
        );
        endAt?.setHours(state.endTime.h);
        endAt?.setMinutes(state.endTime.m);
        const data: AddMentoringSessionDTO = {
          title: state.title,
          description: state.description,
          meetingURL: state.meetingURL,
          mentorName: session.mentorName,
          mentorId: session.mentorId,
          mentoringSessionRequest: {
            id: session.id,
            requestedTeamId: session.teamId,
            requestedTeamName: session.teamName,
            requestedTeamMemberId: session.memberId,
            requestedMentorId: session.mentorId,
            requestedMentorName: session.mentorName,
            country: session.country,
            createdAt: new Date(
              session.createdAt.seconds * 1000
            ).toDateString(),
          },
          duration: getDateDeff(),
          teamId: session.teamId,
          teamName: session.teamName,
          endAt: endAtFull?.toString(),
          startAt: startAtFull?.toString(),
          country: session.country as Country,
        };

        addMentorSessionFunction(data)
          .then((res) => {
            UserNotification({
              isSuccess: true,
              message: "Session successfully created!",
            });
            console.log(res.data);
            app.pushBackURL(DashboardMentoringPages.MENTORING_SESSION_REQUESTS);
            push(`/dashboard/sessions/session/${res.data.data}`);
          })
          .catch(() => {
            UserNotification({
              isSuccess: false,
              message: "Session creation failed!",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  };

  // const [allTimes, setAllTimes] = useState<string[]>([]);
  const onDrop = useCallback((files) => {
    const file: any = files[0];
    const fileType = file?.name
      .split(".")
      .pop()
      .toLowerCase();
    const exList = "xls,pptx,ppt,png,pdf,jpg,jpeg,gif,docx,doc,xlsx,txt,md".split(
      ","
    );

    let b1 = file && exList.filter((ext) => ext === fileType).length > 0;
    let b2 = file && file?.size <= 105255200;
    let errorMessage = "No file was selected";
    if (b1) errorMessage = "Invalid file format";
    if (b2) errorMessage = " Invalid file size";
    if (b1 && b2) {
      if (file) {
        setSelectedFiles((ps) => {
          ps.push({
            file: file,
            id: randomString.generate(),
            url: "",
          });
          return Object.assign([], ps);
        });
      }
    } else {
      UserNotification({
        isSuccess: false,
        message: errorMessage,
      });
    }
  }, []);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  // useEffect(() => {
  //   let times: string[] = [];
  //   for (let i: number = 0; i < 24; i++) {
  //     times.push(`${zeroPad(i, 2)}:00`);
  //     times.push(`${zeroPad(i, 2)}:15`);
  //     times.push(`${zeroPad(i, 2)}:30`);
  //     times.push(`${zeroPad(i, 2)}:45`);
  //   }
  //   setAllTimes(times);
  // }, []);

  const getDateDeff = useMemo(() => {
    return (): string => {
      const totalTime = moment(
        `${state.endDate?.getFullYear()}/${(state.endDate?.getMonth() || -1) +
          1}/${state.endDate?.getDate()} ${state.endTime.h}:${state.endTime.m}`
      ).diff(
        `${state.startDate?.getFullYear()}/${(state.startDate?.getMonth() ||
          -1) + 1}/${state.startDate?.getDate()}  ${state.startTime.h}:${
          state.startTime.m
        }`,
        "minutes"
      );
      if (!isNaN(totalTime) && totalTime >= 0) {
        if (totalTime === 0) {
          return `${0} hours and ${0} minutes`;
        } else {
          const hours = Math.floor(totalTime / 60);
          const minutes = totalTime % 60;
          return `${hours} hours and ${minutes} minutes`;
        }
      } else {
        return "";
      }
    };
  }, [state.startDate, state.endDate, state.startTime, state.endTime]);

  return (
    <div className="create-sr-wrapper">
      <PageHeader title="Create Session" />
      <Container
        fluid
        style={{
          paddingTop: "200px",
          paddingLeft: "50px",
          paddingRight: "50px",
          paddingBottom: "50px",
        }}
      >
        <Row>
          <Col xs={12} className="mb-3">
            <BarLoader
              height={4}
              width={"100%"}
              color={"#006699"}
              loading={loading}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="text-right mb-3">
            <div
              className="cancel-button blue"
              style={{ marginRight: "15px" }}
              onClick={() => {
                push(DashboardMentoringPages.MENTORING_SESSION_REQUESTS);
              }}
            >
              Cancel
            </div>
            <div
              className="save-button"
              style={{ marginLeft: "15px" }}
              onClick={() => {
                saveData();
              }}
            >
              Save
            </div>
          </Col>
        </Row>
        <Row className="py-2">
          <Col xs={12}>
            <label className="font-weight-bold form-label">
              Session title
              <span className="ml-1" style={{ color: "red" }}>
                *
              </span>
            </label>
            <input
              className={
                state.titleError.length < 1 ? "app-input" : "app-input invalid"
              }
              value={state.title}
              onChange={(e) =>
                setState({ ...state, title: e.target.value, titleError: "" })
              }
            />
            <label className="error-message">{state.titleError}</label>
          </Col>
        </Row>
        <Row className="py-2">
          <Col xs={3}>
            <label className="font-weight-bold form-label">
              Mentor
              <span className="ml-1" style={{ color: "red" }}></span>
            </label>
            <br />
            <label className="form-label">{session.mentorName}</label>

            <label className="error-message">{state.mentorError}</label>
          </Col>
          {session.teamName !== "PUBLIC-TEAM" && (
            <Col xs={3}>
              <label className="font-weight-bold form-label">Team</label>
              <br />
              <label className=" form-label">{session.teamName}</label>
              <label className="error-message">{state.teamError}</label>
            </Col>
          )}
          <Col xs={6}>
            <label className="font-weight-bold form-label">Participants</label>
            <div>
              {session.memberNames.map((name, index) => (
                <MemberTag key={index} name={name} />
              ))}
            </div>
            <label className="error-message">{state.membersError}</label>
          </Col>
        </Row>
        <Row className="py-2">
          <Col xs={4}>
            <label className="font-weight-bold form-label">
              Start Date
              <span className="ml-1" style={{ color: "red" }}>
                *
              </span>
            </label>
            <div>
              <DatePicker
                className={
                  state.startDateError.length < 1
                    ? "app-input calender-img"
                    : "app-input calender-img invalid"
                }
                onChange={(date: Date) => {
                  setState({ ...state, startDate: date, startDateError: "" });
                }}
                selected={state.startDate}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="dd/MM/yyyy"
                placeholderText={"DD/MM/YYYY"}
                popperClassName={"customDatePicker"}
                customInput={<input className="app-input-profile" />}
              />
            </div>
            <label className="error-message">{state.startDateError}</label>
          </Col>
          <Col xs={2}>
            <label className="font-weight-bold form-label">
              Start Time
              <span className="ml-1" style={{ color: "red" }}>
                *
              </span>
            </label>
            <div className="d-flex">
              {/* <select
                className={
                  state.startTimeError.length < 1
                    ? "app-input mr-1"
                    : "app-input mr-1 invalid"
                }
                value={
                  zeroPad(state.startTime.h, 2) +
                  ":" +
                  zeroPad(state.startTime.m, 2)
                }
                onChange={(e) => {
                  const time = e.target.value.split(":");
                  setState({
                    ...state,
                    startTime: { ...state.startTime, h: +time[0], m: +time[1] },
                    startTimeError: "",
                  });
                }}
              >
                {allTimes.map((t, index) => (
                  <option key={index} className="time-selector-item" value={t}>
                    {t}
                  </option>
                ))}
              </select> */}
              <input
                type="time"
                // placeholder="00:00"
                value={
                  zeroPad(state.startTime.h, 2) +
                  ":" +
                  zeroPad(state.startTime.m, 2)
                }
                className={
                  state.startTimeError.length < 1
                    ? "app-input mr-1"
                    : "app-input mr-1 invalid"
                }
                onChange={(e) => {
                  const time = e.target.value.split(":");
                  setState({
                    ...state,
                    startTime: { ...state.startTime, h: +time[0], m: +time[1] },
                    startTimeError: "",
                  });
                }}
              />
            </div>
            <label className="error-message">{state.startTimeError}</label>
          </Col>
        </Row>
        <Row className="py-2">
          <Col xs={4}>
            <label className="font-weight-bold form-label">
              End Date
              <span className="ml-1" style={{ color: "red" }}>
                *
              </span>
            </label>
            <div>
              <DatePicker
                className={
                  state.endDateError.length < 1
                    ? "app-input calender-img"
                    : "app-input calender-img invalid"
                }
                onChange={(date: Date) => {
                  setState({ ...state, endDate: date, endDateError: "" });
                }}
                selected={state.endDate}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="dd/MM/yyyy"
                placeholderText={"DD/MM/YYYY"}
                popperClassName={"customDatePicker"}
                customInput={<input className="app-input-profile" />}
              />
            </div>
            <label className="error-message">{state.endDateError}</label>
          </Col>
          <Col xs={2}>
            <label className="font-weight-bold form-label">
              End Time
              <span className="ml-1" style={{ color: "red" }}>
                *
              </span>
            </label>
            <div className="d-flex">
              {/* <select
                className={
                  state.endTimeError.length < 1
                    ? "app-input mr-1"
                    : "app-input mr-1 invalid"
                }
                value={
                  zeroPad(state.endTime.h, 2) +
                  ":" +
                  zeroPad(state.endTime.m, 2)
                }
                onChange={(e) => {
                  const time = e.target.value.split(":");
                  setState({
                    ...state,
                    endTime: { ...state.endTime, h: +time[0], m: +time[1] },
                    endTimeError: "",
                  });
                }}
              >
                {allTimes.map((t, index) => (
                  <option key={index} className="time-selector-item" value={t}>
                    {t}
                  </option>
                ))}
              </select> */}
              <input
                type="time"
                // placeholder="00:00"
                value={
                  zeroPad(state.endTime.h, 2) +
                  ":" +
                  zeroPad(state.endTime.m, 2)
                }
                className={
                  state.endTimeError.length < 1
                    ? "app-input mr-1"
                    : "app-input mr-1 invalid"
                }
                onChange={(e) => {
                  const time = e.target.value.split(":");
                  setState({
                    ...state,
                    endTime: { ...state.endTime, h: +time[0], m: +time[1] },
                    endTimeError: "",
                  });
                }}
              />
            </div>
            <label className="error-message">{state.endTimeError}</label>
          </Col>
          {getDateDeff() !== "" && (
            <Col xs={3} className="ml-5">
              <label className="font-weight-bold form-label">Duration</label>
              <br />
              <label className=" form-label" style={{ paddingTop: "12px" }}>
                {getDateDeff()}
              </label>

              <label className="error-message">{state.durationError}</label>
            </Col>
          )}
        </Row>
        <Row className="py-2">
          <Col xs={12}>
            <label className="font-weight-bold form-label">
              Description
              <span className="ml-1" style={{ color: "red" }}>
                *
              </span>
            </label>
            <textarea
              className={
                state.descriptionError.length < 1
                  ? "app-input"
                  : "app-input invalid"
              }
              style={{ minHeight: "200px" }}
              value={state.description}
              onChange={(e) =>
                setState({
                  ...state,
                  description: e.target.value,
                  descriptionError: "",
                })
              }
            />
            <label className="error-message">{state.descriptionError}</label>
          </Col>
        </Row>
        <Row className="py-2">
          <Col xs={12}>
            <label className="font-weight-bold form-label">Documents</label>
            <div className="d-flex align-items-center">
              <div style={{ marginRight: "100px" }}>
                <button
                  className="app-button"
                  style={{ fontWeight: "lighter" }}
                  onClick={() => {
                    uploadElement.click();
                  }}
                >
                  <MdAdd className="mr-2" style={{ fontSize: "26px" }} />
                  Attach File
                </button>
              </div>
              <div
                {...getRootProps()}
                className="drop-zone d-flex align-items-center"
                style={{
                  border: "2px dashed #a5a5a5",
                  padding: "4px",
                  paddingLeft: "150px",
                  paddingRight: "150px",
                  color: "#a5a5a5",
                  fontSize: "18px",
                }}
              >
                <span className="mr-2" style={{ fontSize: "26px" }}>
                  <IoMdDownload />
                </span>{" "}
                Drop files Here
              </div>
            </div>

            <div>
              {selectedFiles.map((f, index) => (
                <FileTag
                  key={index}
                  file={f}
                  onClose={(f) => {
                    setSelectedFiles((ps) => {
                      return Object.assign(
                        [],
                        ps.filter((f2) => f2.id !== f.id)
                      );
                    });
                  }}
                />
              ))}
            </div>
            <input
              type="file"
              {...getInputProps()}
              ref={(input) => setUploadElement(input)}
              accept=".xls, .pptx, .ppt, .png, .pdf, .jpg, .jpeg, .gif, .docx, .doc, .xlsx, .txt, .md"
              className="d-none"
              onChange={(e) => {
                const file: any = e.target.files ? e.target.files[0] : null;
                const fileType = file?.name
                  .split(".")
                  .pop()
                  .toLowerCase();
                const exList = "xls,pptx,ppt,png,pdf,jpg,jpeg,gif,docx,doc,xlsx,txt,md".split(
                  ","
                );

                let b1 =
                  file && exList.filter((ext) => ext === fileType).length > 0;
                let b2 = file && file?.size <= 105255200;
                let errorMessage = "No file was selected";
                if (b1) errorMessage = "Invalid file format";
                if (b2) errorMessage = " Invalid file size";
                if (b1 && b2) {
                  if (file) {
                    setSelectedFiles((ps) => {
                      ps.push({
                        file: file,
                        id: randomString.generate(),
                        url: "",
                      });
                      return Object.assign([], ps);
                    });
                  }
                } else {
                  UserNotification({
                    isSuccess: false,
                    message: errorMessage,
                  });
                }
              }}
            />
            <label className="error-message">{state.fileURLsError}</label>
          </Col>
        </Row>
        <Row className="py-2">
          <Col xs={12}>
            <label className="font-weight-bold form-label">
              Meeting Link
              <span className="ml-1" style={{ color: "red" }}>
                *
              </span>
            </label>
            <input
              className={
                state.meetingURLError.length < 1
                  ? "app-input"
                  : "app-input invalid"
              }
              onChange={(e) =>
                setState({
                  ...state,
                  meetingURL: e.target.value,
                  meetingURLError: "",
                })
              }
            />
            <label className="error-message">{state.meetingURLError}</label>
          </Col>
        </Row>
      </Container>
      {userRole.isAdmin && (
        <SelectCountry
          show={modalShow}
          onHide={() => {
            setModalShow(false);
          }}
        />
      )}
    </div>
  );
};

export default CreateSession;
